import React from 'react';

/**
 * All of the SVG icons an application needs are stored here.
 *
 * The 'Icon' component binds itself to its matching `<symbol>` element found
 * in this component.
 */

export type IconId =
  | 'edit'
  | 'tick'
  | 'breifcase'
  | 'breifcase_alt'
  | 'plus'
  | 'profile'
  | 'profile_alt'
  | 'print'
  | 'bell'
  | 'hamburger'
  | 'cross'
  | 'lock'
  | 'home'
  | 'phone'
  | 'clock'
  | 'book'
  | 'book_alt'
  | 'bookmark'
  | 'chevron'
  | 'exclamation'
  | 'kebab'
  | 'sun'
  | 'cloud'
  | 'ice';

const strokeWidth = '5px';
const strokeLine = 'round';

const Icons = () => (
  <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
    <symbol id="id_caret_up_icon" viewBox="0 0 24 24">
      <path fill="currentColor" fillRule="evenodd" d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
    </symbol>

    <symbol id="id_caret_down_icon" viewBox="0 0 24 24">
      <path fill="currentColor" fillRule="evenodd" d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
    </symbol>
    <symbol id="edit" viewBox="0 0 20.771 20.771">
      <path d="M17.526 0a3.246 3.246 0 012.6 5.193l-1.3 1.3-4.546-4.546 1.3-1.3A3.231 3.231 0 0117.526 0zM1.3 14.93L0 20.771l5.842-1.3L17.85 7.465l-4.543-4.544zm13.215-7.555l-9.087 9.088-1.119-1.119L13.4 6.256z" />
    </symbol>
    <symbol fill="currentColor" id="id_bin_icon" viewBox="0 0 24 24">
      <g fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        <line x1="10" x2="10" y1="11" y2="17" />
        <line x1="14" x2="14" y1="11" y2="17" />
      </g>
    </symbol>
    <symbol id="tick" viewBox="0 0 30 30">
      <path
        fill="none"
        strokeWidth="3px"
        strokeLinecap={strokeLine}
        strokeLinejoin={strokeLine}
        d="m2.701,13.77999l11.144,9.748l12.5,-20.741"
      />
    </symbol>
    <symbol id="id_minus_icon" viewBox="0 0 24 24">
      <path fill="currentColor" fillRule="evenodd" d="M19 13H5v-2h14v2z" />
    </symbol>
    <symbol id="id_plus_icon" viewBox="0 0 24 24">
      <path fill="currentColor" fillRule="evenodd" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </symbol>
    <symbol id="breifcase" viewBox="-1 0 27 25">
      <path d="M23.209 23.543H1.763A1.766 1.766 0 010 21.78V6.81a1.766 1.766 0 011.763-1.763h21.446a1.764 1.764 0 011.76 1.763v14.969a1.764 1.764 0 01-1.76 1.763z" />
      <path d="M7.536 5.617V2.81A1.79 1.79 0 019.299 1h6.37a1.791 1.791 0 011.765 1.81v2.807" />
      <path d="M10.08 13.324H0M24.969 13.324H14.813M14.005 16.359h-3.033a.549.549 0 01-.549-.549v-4.552a.548.548 0 01.549-.549h3.035a.548.548 0 01.549.549v4.55a.549.549 0 01-.549.549z" />
    </symbol>
    <symbol id="breifcase_alt" viewBox="-1 0 27 25" fill="#68d3d9">
      <path
        stroke="none"
        d="M23.209 23.543H1.763A1.766 1.766 0 010 21.78V6.81a1.766 1.766 0 011.763-1.763h21.446a1.764 1.764 0 011.76 1.763v14.969a1.764 1.764 0 01-1.76 1.763z"
      />
      <path
        fill="none"
        stroke="#68d3d9"
        d="M7.536 5.617V2.81A1.79 1.79 0 019.299 1h6.37a1.791 1.791 0 011.765 1.81v2.807"
        strokeWidth={2}
      />
      <path
        strokeWidth={2}
        stroke="white"
        d="M10.08 13.324H0M24.969 13.324H14.813M14.005 16.359h-3.033a.549.549 0 01-.549-.549v-4.552a.548.548 0 01.549-.549h3.035a.548.548 0 01.549.549v4.55a.549.549 0 01-.549.549z"
      />
    </symbol>
    <symbol id="plus" viewBox="0 0 46 46">
      <path strokeLinecap={strokeLine} strokeWidth={strokeWidth} d="M23.5 3.5v39M42.5 22.5h-39" />
    </symbol>
    <symbol id="profile" viewBox="0 0 28 28">
      <defs>
        <clipPath id="profile__a">
          <circle stroke="#707070" r="11.5" cy="86.13" cx="1799.06494" />
        </clipPath>
      </defs>
      <g>
        <circle fill="none" r="11.5" cy="14.5" cx="14.5" />
        <path d="m14.67606,15.464a3.4,3.4 0 0 0 3.429,-3.429a3.534,3.534 0 0 0 -3.429,-3.428a3.534,3.534 0 0 0 -3.429,3.429a3.534,3.534 0 0 0 3.429,3.428zm0,1.614a5.853,5.853 0 0 0 -5.849,5.849c0,0.605 0.2,1.21 0.2,1.613a8.673,8.673 0 0 0 5.445,1.613a11.408,11.408 0 0 0 5.647,-1.613a4.441,4.441 0 0 0 0.2,-1.613a5.453,5.453 0 0 0 -5.643,-5.849z" />
      </g>
    </symbol>
    <symbol id="profile_alt" viewBox="0 0 28 28">
      <defs>
        <clipPath id="profile__a">
          <circle stroke="#707070" r="11.5" cy="86.13" cx="1799.06494" />
        </clipPath>
      </defs>
      <g>
        <circle r="11.5" cy="14.5" cx="14.5" fill="none" stroke="#68d3d9" strokeWidth="2px" />
        <path d="m14.67606,15.464a3.4,3.4 0 0 0 3.429,-3.429a3.534,3.534 0 0 0 -3.429,-3.428a3.534,3.534 0 0 0 -3.429,3.429a3.534,3.534 0 0 0 3.429,3.428zm0,1.614a5.853,5.853 0 0 0 -5.849,5.849c0,0.605 0.2,1.21 0.2,1.613a8.673,8.673 0 0 0 5.445,1.613a11.408,11.408 0 0 0 5.647,-1.613a4.441,4.441 0 0 0 0.2,-1.613a5.453,5.453 0 0 0 -5.643,-5.849z" />
      </g>
    </symbol>
    <symbol id="print" viewBox="0 0 25 25">
      <g strokeLinecap={strokeLine} strokeLinejoin={strokeLine}>
        <path d="m6.897,9.821l0,-6.821l11.692,0l0,6.821" />
        <path d="m6.897,18.59l-1.947,0a1.949,1.949 0 0 1 -1.95,-1.948l0,-4.871a1.949,1.949 0 0 1 1.95,-1.95l15.59,0a1.949,1.949 0 0 1 1.947,1.95l0,4.872a1.949,1.949 0 0 1 -1.949,1.949l-1.948,0" />
        <path d="m6.897,14.692l11.692,0l0,7.795l-11.692,0l0,-7.795z" />
      </g>
    </symbol>
    <symbol id="bell" viewBox="0 0 17.249 21.6">
      <path d="M8.613 21.6a2.543 2.543 0 002.595-2.859h-5.2A2.546 2.546 0 008.613 21.6zM17.035 16.004c-.83-1.095-2.465-1.737-2.465-6.64 0-5.032-2.225-7.054-4.293-7.54-.195-.049-.334-.113-.334-.318v-.158-.031a1.317 1.317 0 10-2.633 0v.189c0 .2-.144.27-.334.318-2.079.489-4.3 2.506-4.3 7.538 0 4.9-1.634 5.539-2.465 6.64a1.071 1.071 0 00.855 1.715h15.113a1.071 1.071 0 00.854-1.716z" />
    </symbol>
    <symbol id="hamburger" viewBox="0 0 45 34">
      <path strokeLinecap={strokeLine} strokeWidth={strokeWidth} d="M3 31h19M3 17h39M22 3h20" />
    </symbol>
    <symbol id="cross" viewBox="0 0 39.985 39.986">
      <path strokeLinecap={strokeLine} strokeWidth={strokeWidth} d="M4.243 4.243l31.5 31.5M35.743 4.243l-31.5 31.5" />
    </symbol>
    <symbol id="lock" viewBox="0 0 30 30">
      <path d="m24.20797,14.87878l-1.273,0l0,-3.817a8.059,8.059 0 1 0 -16.118,0l0,3.817l-1.272,0a2.546,2.546 0 0 0 -2.545,2.545l0,10.179a2.546,2.546 0 0 0 2.545,2.545l18.663,0a2.546,2.546 0 0 0 2.545,-2.545l0,-10.179a2.546,2.546 0 0 0 -2.545,-2.545zm-5.514,0l-7.635,0l0,-3.817a3.818,3.818 0 1 1 7.635,0l0,3.817z" />
    </symbol>
    <symbol id="home" viewBox="0 0 24.882 22.574">
      <path d="M24.882 13.594L12.441 3.937 0 13.594V9.657L12.441 0l12.441 9.657zm-3.11-.351v9.331h-6.221v-6.22h-6.22v6.221H3.11v-9.332l9.331-7z" />
    </symbol>
    <symbol id="phone" viewBox="0 0 32.56 27.688">
      <path d="M23.357 20.593l-5.322-2.217a1.418 1.418 0 00-1.33.3L14.34 21.48a17.318 17.318 0 01-8.279-8.279l2.809-2.365a.963.963 0 00.3-1.33L7.1 4.328a1.194 1.194 0 00-1.33-.591L.887 4.775A1.288 1.288 0 000 5.958a21.766 21.766 0 0021.731 21.731c.591 0 1.035-.3 1.035-.887l1.183-4.874a1.287 1.287 0 00-.591-1.33zM28.68 1.079a7.943 7.943 0 00-10.792 2.809 7.943 7.943 0 002.809 10.792l.591 3.548 2.513-2.513a7.921 7.921 0 008.722-6.948 8.068 8.068 0 00-3.844-7.687zm.148 7.835h-3.253v3.252h-1.922V8.914h-3.252v-2.07h3.252V3.74h1.922v3.252h3.252z" />
    </symbol>
    <symbol id="clock" viewBox="0 0 25 25">
      <path d="m16.4,18.24l-4.288,-4.287l0,-5.746l2.6,0l0,4.668l3.528,3.525l-1.84,1.84zm-2.986,-15.24a10.414,10.414 0 1 0 10.414,10.414a10.414,10.414 0 0 0 -10.414,-10.414zm0,18.225a7.811,7.811 0 1 1 7.811,-7.811a7.811,7.811 0 0 1 -7.811,7.811z" />
    </symbol>
    <symbol id="book" viewBox="0 0 32 40">
      <g>
        <path d="m27.915,16.662l-3.6,-2.376l-3.6,2.376l0,-13.662l7.2,0l0,13.662z" />
        <path d="m29.916,3l-20.627,0a3.123,3.123 0 0 0 -3.123,3.123l0,0l0,3.112c0.015,-0.065 0.091,4.454 0,4.552l0,2.541c0.09,0.039 0.015,5.548 0,5.657l0,2.54c-0.024,-0.007 -0.1,5.765 0,5.657l0,2.892a3.123,3.123 0 0 0 3.124,3.126l20.626,0a3.123,3.123 0 0 0 3.123,-3.123l0,-26.954a3.123,3.123 0 0 0 -3.123,-3.123z" />
        <path
          fill="white"
          d="m4.861,9.097l3.941,0a1.861,1.861 0 0 1 1.86,1.857l0,0a1.861,1.861 0 0 1 -1.861,1.861l-3.94,0a1.861,1.861 0 0 1 -1.861,-1.861l0,0a1.861,1.861 0 0 1 1.861,-1.857z"
        />
        <path
          fill="white"
          d="m4.861,17.295l3.941,0a1.861,1.861 0 0 1 1.86,1.856l0,0a1.861,1.861 0 0 1 -1.861,1.861l-3.94,0a1.861,1.861 0 0 1 -1.861,-1.861l0,0a1.861,1.861 0 0 1 1.861,-1.856z"
        />
        <path
          fill="white"
          d="m4.861,25.492l3.941,0a1.861,1.861 0 0 1 1.861,1.861l0,0a1.861,1.861 0 0 1 -1.861,1.861l-3.941,0a1.861,1.861 0 0 1 -1.861,-1.861l0,0a1.861,1.861 0 0 1 1.861,-1.861z"
        />
      </g>
    </symbol>
    <symbol id="book_alt" viewBox="0 0 30 30">
      <g>
        <path d="m4.4,7.58l2.96,0a1.4,1.4 0 0 1 1.4,1.4l0,0a1.4,1.4 0 0 1 -1.4,1.4l-2.96,0a1.4,1.4 0 0 1 -1.4,-1.4l0,0a1.4,1.4 0 0 1 1.4,-1.4z" />
        <path d="m4.4,13.738l2.96,0a1.4,1.4 0 0 1 1.4,1.4l0,0a1.4,1.4 0 0 1 -1.4,1.4l-2.96,0a1.4,1.4 0 0 1 -1.4,-1.4l0,0a1.4,1.4 0 0 1 1.4,-1.4z" />
        <path d="m4.4,19.896l2.96,0a1.4,1.4 0 0 1 1.4,1.4l0,0a1.4,1.4 0 0 1 -1.4,1.4l-2.96,0a1.4,1.4 0 0 1 -1.4,-1.4l0,0a1.4,1.4 0 0 1 1.4,-1.4z" />
        <path d="m21.718,13.263l-2.7,-1.785l-2.7,1.785l0,-10.263l5.409,0l-0.009,10.263z" />
        <path d="m23.222,3l-0.517,0l0,12.468l-3.691,-2.668l-3.691,2.668l0,-12.468l-7.6,0a2.346,2.346 0 0 0 -2.346,2.346l0,0l0,1.508l2.258,0a1.959,1.959 0 0 1 1.958,1.958l0,0.332a1.959,1.959 0 0 1 -1.954,1.956l-2.258,0l0,1.909l2.258,0a1.959,1.959 0 0 1 1.954,1.961l0,0.33a1.959,1.959 0 0 1 -1.959,1.959l-2.253,0l0,1.908l2.258,0a1.958,1.958 0 0 1 1.954,1.961l0,0l0,0.332a1.959,1.959 0 0 1 -1.959,1.959l-2.253,0l0,2.172a2.346,2.346 0 0 0 2.346,2.346l15.495,0a2.346,2.346 0 0 0 2.346,-2.346l0,-20.245a2.346,2.346 0 0 0 -2.346,-2.346z" />
      </g>
    </symbol>
    <symbol id="bookmark" viewBox="0 0 25 30">
      <path d="m22.148,28.564l-9.574,-6.681l-9.574,6.681l0,-23.564a2.122,2.122 0 0 1 2.228,-2l14.693,0a2.122,2.122 0 0 1 2.228,2l-0.001,23.564z" />
    </symbol>
    <symbol id="chevron" viewBox="0 0 25 50">
      <path
        strokeWidth={strokeWidth}
        strokeLinejoin={strokeLine}
        strokeLinecap={strokeLine}
        fill="none"
        d="m5,5l19.515,19.516l-19.515,19.516"
      />
    </symbol>
    <symbol id="exclamation" viewBox="0 0 14 45">
      <text fontSize="50px" fontFamily="Lato" fontWeight="800" transform="translate(0 39)">
        <tspan x="0" y="0">
          !
        </tspan>
      </text>
    </symbol>
    <symbol id="kebab" viewBox="0 0 20 80">
      <path d="m19.53125,39.0625c0,5.39362 -4.372,9.76563 -9.76563,9.76563s-9.76563,-4.372 -9.76563,-9.76563s4.372,-9.76563 9.76563,-9.76563s9.76563,4.372 9.76563,9.76563zm0,0" />
      <path d="m19.53125,9.76563c0,5.39362 -4.372,9.76563 -9.76563,9.76563s-9.76563,-4.372 -9.76563,-9.76563s4.372,-9.76563 9.76563,-9.76563s9.76563,4.372 9.76563,9.76563zm0,0" />
      <path d="m19.53125,68.35938c0,5.39362 -4.372,9.76563 -9.76563,9.76563s-9.76563,-4.372 -9.76563,-9.76563s4.372,-9.76563 9.76563,-9.76563s9.76563,4.372 9.76563,9.76563zm0,0" />
    </symbol>
    <symbol id="sun" viewBox="0 0 40 40">
      <path
        d="M18.87,39.529a1.583,1.583,0,0,1-.471-1.165V34.618a1.473,1.473,0,0,1,.471-1.128,1.663,1.663,0,0,1,2.278,0,1.529,1.529,0,0,1,.451,1.128v3.745a1.583,1.583,0,0,1-.471,1.165A1.537,1.537,0,0,1,20,40,1.509,1.509,0,0,1,18.87,39.529ZM31.9,34.149l-2.674-2.671a1.834,1.834,0,0,1-.433-1.224,1.478,1.478,0,0,1,1.488-1.485,1.594,1.594,0,0,1,1.129.432l2.749,2.691a1.634,1.634,0,0,1,.453,1.147,1.52,1.52,0,0,1-.453,1.11,1.676,1.676,0,0,1-2.259,0Zm-26.064-.02a1.514,1.514,0,0,1-.451-1.11,1.745,1.745,0,0,1,.432-1.147l2.769-2.689A1.446,1.446,0,0,1,9.7,28.749a1.591,1.591,0,0,1,1.129.433,1.4,1.4,0,0,1,.451,1.071,1.774,1.774,0,0,1-.451,1.2L8.154,34.129A1.88,1.88,0,0,1,7,34.581,1.88,1.88,0,0,1,5.838,34.129Zm9.228-5.644a9.853,9.853,0,0,1-3.579-3.574,9.987,9.987,0,0,1-1.3-4.929,9.486,9.486,0,0,1,1.318-4.891A9.829,9.829,0,0,1,15.1,11.5a9.667,9.667,0,0,1,8.7-.526,9.805,9.805,0,0,1,3.126,2.107A9.866,9.866,0,0,1,29.793,20a9.5,9.5,0,0,1-1.318,4.911A9.853,9.853,0,0,1,24.9,28.485a9.829,9.829,0,0,1-9.829,0ZM1.62,21.6a1.543,1.543,0,0,1-1.131-.471A1.565,1.565,0,0,1,0,19.981a1.586,1.586,0,0,1,.471-1.167A1.631,1.631,0,0,1,1.6,18.363H5.442a1.426,1.426,0,0,1,1.092.471,1.766,1.766,0,0,1,.019,2.295,1.4,1.4,0,0,1-1.092.471Zm32.956-.02a1.4,1.4,0,0,1-1.092-.469,1.625,1.625,0,0,1-.433-1.129,1.682,1.682,0,0,1,.451-1.167,1.471,1.471,0,0,1,1.074-.451h3.8a1.6,1.6,0,0,1,1.129,2.748,1.535,1.535,0,0,1-1.129.469ZM29.227,10.837a1.6,1.6,0,0,1-.433-1.129,1.462,1.462,0,0,1,.433-1.11L31.9,5.832a1.586,1.586,0,0,1,1.111-.451,1.482,1.482,0,0,1,1.129.471,1.537,1.537,0,0,1,.471,1.129,1.585,1.585,0,0,1-.453,1.165l-2.749,2.691a1.659,1.659,0,0,1-1.129.451A1.365,1.365,0,0,1,29.227,10.837Zm-20.64-.02L5.838,8.128a1.573,1.573,0,0,1-.451-1.147,1.746,1.746,0,0,1,.432-1.149,1.811,1.811,0,0,1,1.206-.469,1.585,1.585,0,0,1,1.111.451L10.828,8.58a1.458,1.458,0,0,1,.451,1.11A1.543,1.543,0,0,1,9.7,11.269,1.459,1.459,0,0,1,8.587,10.818Zm10.3-4.27a1.483,1.483,0,0,1-.489-1.09V1.618A1.531,1.531,0,0,1,18.87.489,1.566,1.566,0,0,1,20.019,0a1.5,1.5,0,0,1,1.129.471A1.536,1.536,0,0,1,21.619,1.6V5.457a1.428,1.428,0,0,1-.471,1.09,1.576,1.576,0,0,1-1.129.433A1.633,1.633,0,0,1,18.888,6.547Z"
        fill="#f7b06b"
      />
    </symbol>
    <symbol id="cloud" viewBox="0 0 40 30">
      <path
        d="M22.5,0A12.778,12.778,0,0,0,10,10a10,10,0,0,0,0,20H32.5A7.49,7.49,0,0,0,40,22.5,8.133,8.133,0,0,0,35,15V12.5A12.5,12.5,0,0,0,22.5,0Z"
        fill="#58c0cc"
      />
    </symbol>

    <svg id="ice" viewBox="0 0 16 19">
      <defs>
        <clipPath id="id_ice_path">
          <rect fill="none" width="16" height="19" />
        </clipPath>
      </defs>
      <path
        fill="currenColor"
        d="M-10954.15-4836.173l-5.943,1.6-5.43,8.993,1.526,5.555,6.355-1.417,5.292-8.934Z"
        transform="translate(10966.731 4837.984)"
      />
      <g clipPath="url(#id_ice_path)">
        <g transform="translate(-1.415 -1.528)">
          <path
            fill="none"
            d="M-10954-4836.072l-5.889,1.488-5.441,8.993,1.484,5.657,6.188-1.571,5.408-8.911Z"
            transform="translate(10968.096 4839.512)"
          />
          <g transform="translate(0 0)">
            <g transform="translate(9.799 0) rotate(30)">
              <g transform="translate(0 0)">
                <path
                  fill="#3d3d3d"
                  d="M9.929,14.365a.463.463,0,0,0-.012-.156.3.3,0,0,0-.323-.2.329.329,0,0,0-.283.284c-.014.139-.024.882-.024.882l-1.736.05.254-9.974L9.545,5.21s-.186,7.282-.191,7.463c0,.033,0,.066,0,.1a.291.291,0,0,0,.3.3.33.33,0,0,0,.318-.321c0-.039,0-.078,0-.117l.2-7.614a.419.419,0,0,0-.081-.339c-.086-.091-.174-.179-.261-.268C9.64,4.218,5.719.189,5.7.17A.325.325,0,0,0,5.241.2L.654,4.893a.4.4,0,0,0-.118.179.474.474,0,0,0-.011.109l-.009.347-.26,9.914c0,.088-.006.177-.007.265a.3.3,0,0,0,.091.226l.09.086,4.183,4.008.11.105a.321.321,0,0,0,.429.021c.087-.07.164-.155.244-.232l4.365-4.195a.422.422,0,0,0,.124-.17A.527.527,0,0,0,9.9,15.4C9.9,15.328,9.928,14.438,9.929,14.365ZM9.155,4.619l-1.442.037L6.473,1.864Zm-3.7-3.5L7.033,4.673l-3.345.085Zm-1.059.8L3.007,4.776l-1.442.037ZM1.138,5.425,2.882,5.38,2.868,5.9a.287.287,0,0,0,.3.293.325.325,0,0,0,.318-.309L3.5,5.365l3.685-.094-.262,9.975-3.685.094.206-7.847a.287.287,0,0,0-.3-.293.325.325,0,0,0-.318.309L2.62,15.355.877,15.4ZM4.979,19.234,4.224,17.65a.3.3,0,0,0-.41-.13.309.309,0,0,0-.155.405l.281.589L1.305,15.99l1.414-.036.391.82a.3.3,0,0,0,.41.13.309.309,0,0,0,.155-.405l-.268-.562,3.318-.085Zm1.079-.774,1.356-2.626L8.828,15.8Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </svg>
);

export { Icons };

// bookmark_coloured_icon
// bookmark_icon
// phone_coloured_icon
